import { SingleStat, WidgetCard, WidgetTooltip, educatorsIcon } from './WidgetPrimitives';

export interface EducatorsWidgetData {
  total_educator_count?: number;
  filtered_educator_count?: number;
  filtered_educator_percentage?: number;
}

interface EducatorsWidgetProps {
  data: EducatorsWidgetData;
}

const TOOLTIP = (
  <WidgetTooltip
    heading="Educators"
    description="Shows the total number of educators you supervise, and the number of educators included in the currently applied filters."
  />
);

const EducatorsWidget = ({
  data: { total_educator_count: total = 0, filtered_educator_count: filtered = 0, filtered_educator_percentage: filteredPercent = 0 }
}: EducatorsWidgetProps) => (
  <WidgetCard title="Educators" icon={educatorsIcon} tooltip={TOOLTIP}>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <SingleStat value={`${total}`} label="Total" showTopBorder={false} />
      <SingleStat value={`${filtered}`} label="Filtered" />
    </div>
  </WidgetCard>
);

export default EducatorsWidget;
